import { Injectable, inject } from '@angular/core'
import { Subject } from 'rxjs'
import { OrderStateServiceWrapper } from '../../../store/state/order/order.state.wrapper.service'
import { MenuItem } from 'primeng/api'
export interface MenuChangeEvent {
    key: string
    routeEvent?: boolean
}
@Injectable({
    providedIn: 'root'
})
export class AppMenuService {

    orderStateService = inject(OrderStateServiceWrapper)

    private menuSource = new Subject<MenuChangeEvent>()
    private resetSource = new Subject()
    private resetOtherSource = new Subject<MenuItem>()

    menuSource$ = this.menuSource.asObservable()
    resetSource$ = this.resetSource.asObservable()
    resetOtherSource$ = this.resetOtherSource.asObservable()

    onMenuStateChange(event: MenuChangeEvent) {
        this.menuSource.next(event)
    }

    reset() {
        this.resetSource.next(true)
    }

    resetOther(item: MenuItem) {
        this.resetOtherSource.next(item);
    }

    resetState() {
        this.orderStateService.reset()
    }
}
